import React, { useEffect } from 'react';
import { Tab, Button, Typography } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import {
  PageContainer,
  TabListFp,
  SimpleDialog,
  Icons,
  InputV2,
  SelectV,
  ButtonLoading,
} from 'components';
import { useNavigate, useLocation } from 'react-router-dom';
import { useQuery, useBusiness } from 'hooks';
import { useStyles } from './Style';
import { FormProvider, useForm } from 'react-hook-form';
import Grants from './Grants';
import GrantsServices from './Grants/services/GrantsServices';
import ActiveDevices from './ActiveDevices';
import ChangePassword from './ChangePassword';
import ChangeUsername from './ChangeUsername';
import ActivityLog from './ActivityLog';
import createToast from 'components/Toast/Toast';
import useCustomHook from './hooks';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';

const DEFAULT_GRANT_DATA_TYPE = 'username';

const UserSettings = () => {
  // -- STATES --//
  const {
    panelClientId,
    setPanelClientId,
    isNewPermissionOpen,
    setIsNewPermissionOpen,
    grantUserDataType,
    setGrantUserDataType,
    resfreshList,
    setRefreshList,
    setGrantUserData,
    isLoading,
    setIsLoading,

    activeTab,
    setActiveTab,
  } = useCustomHook();

  // -- HOOKS --//
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const business = useBusiness();
  const query = useQuery();
  const methods = useForm();

  const { handleSubmit, /* reset, */ control, register } = methods;
  const tabEnKeys = [
    'grants',
    'active-devices',
    'activity-log',
    'change-username',
    'change-password',
  ];

  let actionsList = getDynamicObjectAction([
    'AccessGrantedBusinessTab',
    'AccessDeviceBusinessTab',
    'reportActivityBusinessTab',
    'updateUserNameBusinessTab',
    'updatePasswordBusinessTab']);

  const getDataFromGrants = (data) => {
    let isExist = data.find((e) => e.clientId === '18415775e07144e629a3780a18f2e873e');
    setPanelClientId(isExist);
  };

  let panels = [
    { label: 'دسترسی‌های اعطا شده', value: <Grants resfreshList={resfreshList} parentCallback={getDataFromGrants} />, action: 'AccessGrantedBusinessTab' },
    { label: 'دستگاه‌های فعال', value: <ActiveDevices />, action: 'AccessDeviceBusinessTab' },
    { label: 'گزارش فعالیت', value: <ActivityLog />, action: 'reportActivityBusinessTab' },
    { label: 'نام کاربری', value: <ChangeUsername />, action: 'updateUserNameBusinessTab' },
    { label: 'تغییر رمز عبور', value: <ChangePassword />, action: 'updatePasswordBusinessTab' },
  ];

  const newPanels = panels.filter(panel => actionsList[panel.action]);
  panels = newPanels


  useEffect(() => {
    const newTabIndex = !query.get('part') ? 1 : tabEnKeys.indexOf(query.get('part')) + 1;
    setActiveTab(`${newTabIndex}`);
  }, [query]);


  const handleCloseNewPermission = () => {
    setIsNewPermissionOpen(false);
    setGrantUserData('');
    setGrantUserDataType(DEFAULT_GRANT_DATA_TYPE);
  };
  const onSubmit = async (user) => {
    setIsLoading(true);
    try {
      const body = {
        identityType: user?.grantType,
        client_id: '18415775e07144e629a3780a18f2e873e',
      };
      await GrantsServices.postUserGrant(user?.personData, body);
      createToast('موفق', 'درخواست دسترسی ایجاد شد و پس از تایید شما فعال خواهد شد.', 'success');

      setIsNewPermissionOpen(false);
      setIsLoading(false);
      setRefreshList(body);
    } catch (error) {
      setIsLoading(false);
    }
  };



  // -- Local Variables --//
  let grantTypeOptions = [
    { value: 'username', label: 'نام کاربری' },
    { value: 'email', label: 'پست الکترونیک' },
    { value: 'phone_number', label: 'تلفن همراه' },
    { value: 'id', label: 'شناسه' },
    { value: 'nationalcode', label: 'کد ملی' },
    // { value: 'ip', label: 'آدرس IP' }
  ];

  const hint = null;

  return (
    <PageContainer
      title="مدیریت کاربری"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.USER_SETTINGS}
      meta={
        activeTab === 1 &&
        panelClientId === undefined && (
          <Button color="primary" variant="contained" onClick={() => setIsNewPermissionOpen(true)}>
            اعطای دسترسی جدید
          </Button>
        )
      }
    >
      <TabContext value={activeTab}>
        <TabListFp
          style={{ marginTop: -15 }}
          onChange={(e, v) =>
            navigate({
              pathname: location.pathname,
              search: `?part=${tabEnKeys[v - 1]}`,
            })
          }
          variant="scrollable"
          scrollButtons="auto"
        >
          {panels.map((tab, index) => (
            <Tab key={String(index + 1)} label={tab.label} value={String(index + 1)} />




          ))}
        </TabListFp>

        {panels.map((tab, index) => (
          <TabPanel key={String(index + 1)} value={String(index + 1)} className={classes.tabPanel} >
            {tab.value}
          </TabPanel>

        ))}

      </TabContext>
      <SimpleDialog
        title={`اعطای دسترسی جدید به ${business.username}`}
        open={isNewPermissionOpen}
        icon={<Icons icon='users2' color='#ccc' size='18' />}
        actions={
          <>
            <ButtonLoading
              name="ثبت دسترسی"
              loading={isLoading}
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
            />
            <Button variant="contained" onClick={handleCloseNewPermission}>
              انصراف
            </Button>
          </>
        }
        onClose={handleCloseNewPermission}
      >
        <Typography className={classes.newPermissionHint}>
          در صورت تمایل می‌توانید به یک کاربر دیگر اجازه دهید بجایتان وارد این پذیرنده شود‌.
        </Typography>
        <FormProvider {...methods}>
          <form
            onSubmit={(e) => e.preventDefault()}
            className={classes.form}
            noValidate
            autoComplete="off"
          >
            <SelectV
              name="grantType"
              options={grantTypeOptions}
              label="نوع شناسایی"
              control={control}
              register={register}
              rules={['required']}
              onChangeFunc={(k, e) => {
                setGrantUserDataType(e?.target?.value);
              }}
              defaultValue={grantUserDataType}
              errors={{}}
              fullWidth
            />
            <InputV2
              control={control}
              register={register}
              errors={{}}
              rules={['required']}
              name="personData"
              label={`${grantTypeOptions.find((v) => v?.value == grantUserDataType)?.label
                } کاربر مورد نظر`}
              mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
              fullWidth
              dir="ltr"
              placeholder=""
              defaultValue={null}
              onChangeValue={(v) => {
                setGrantUserData(v);
              }}
            />
          </form>
        </FormProvider>
      </SimpleDialog>
    </PageContainer >
  );
};

export default UserSettings;
